import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { SocioEmotionalSkill, Suggestion } from '../../socio-emotional-skills-test/socio-emotional-skills-test.models';
import { SkillScore } from '../socio-emotional-skills-test-results.models';
import { SocioEmotionalSkillSuggestionProgress } from './socio-emotional-skills-test-results-suggestions.models';

const STUDENT_SUGGESTION_PROGRESS_URL = 'api/socioEmotionalSuggestionProgress/student';

@Component({
  selector: 'app-socio-emotional-skills-test-results-suggestions',
  templateUrl: './socio-emotional-skills-test-results-suggestions.component.html',
  styleUrls: ['./socio-emotional-skills-test-results-suggestions.component.scss']
})
export class SocioEmotionalSkillsTestResultsSuggestionsComponent implements OnInit {
  @Input() skills: SocioEmotionalSkill[] = [];
  @Input() skillScores: SkillScore[] = [];

  isLoading = false;
  suggestions: Map<string, Suggestion[]> = new Map();
  completedSuggestionIds: Set<string> = new Set();

  swiperBreakpoints = {
    0: { slidesPerView: 1.1, spaceBetween: 10 },
    480: { slidesPerView: 2, spaceBetween: 15 },
    768: { slidesPerView: 3, spaceBetween: 15 },
    1024: { slidesPerView: 3, spaceBetween: 20 },
    1280: { slidesPerView: 5, spaceBetween: 20 }
  };
  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.fetchStudentSuggestionProgress();
  }

  private fetchStudentSuggestionProgress(): void {
    this.isLoading = true;
    this.apiService.get({ api: STUDENT_SUGGESTION_PROGRESS_URL })
      .subscribe({
        next: (progressList: SocioEmotionalSkillSuggestionProgress[]) => {
          this.completedSuggestionIds = new Set(progressList.map(p => p.suggestion));
          this.groupSuggestionsByLevel();
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching user suggestion progress:', err);
          this.isLoading = false;
        }
      });
  }

  private groupSuggestionsByLevel(): void {
    const map: Map<string, Suggestion[]> = new Map();

    this.skills.forEach(skill => {
      const score = this.getScoreForSkill(skill._id);
      const level = this.getMatchingLevel(skill, score);
      const levelName = level ? level.name.trim() : '';

      if (level) {
        level.suggestions.forEach(suggestion => {
          suggestion.completed = this.isSuggestionCompleted(suggestion._id);
          if (!map.has(levelName)) map.set(levelName, []);
          map.get(levelName)!.push(suggestion);
        });
      }
    });

    this.suggestions = map;
  }

  private getScoreForSkill(skillId: string): number {
    return this.skillScores.find(s => s.skill._id === skillId)?.average ?? 0;
  }

  private getMatchingLevel(skill: SocioEmotionalSkill, score: number) {
    return skill.levels.find(level => score >= level.minScore && score <= level.maxScore);
  }

  private isSuggestionCompleted(suggestionId: string): boolean {
    return this.completedSuggestionIds.has(suggestionId);
  }

  getSkillLevelName(suggestion: Suggestion): string {
    const skill = this.skills.find(s => s.levels.some(l => l.suggestions.includes(suggestion)));
    return skill ? skill.name : '';
  }
}
